import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { getNodeReactComponent } from '../components/context';
import { XFlowNodeCommands } from '../constant';
import { Disposable } from '../../common/disposable';
import { XFLOW_DEFAULT_NODE } from '../../constants';
export var NsAddNode;
(function (NsAddNode) {
    /** Command: 用于注册named factory */
    NsAddNode.command = XFlowNodeCommands.ADD_NODE;
    /** hookName */
    NsAddNode.hookKey = 'addNode';
})(NsAddNode || (NsAddNode = {}));
let AddNodeCommand = 
/** 创建节点命令 */
class AddNodeCommand {
    constructor() {
        /** 执行Cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            const { args, hooks: runtimeHook } = ctx.getArgs();
            const hooks = ctx.getHooks();
            const result = yield hooks.addNode.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const { createNodeService, cellFactory, commandService, options } = handlerArgs;
                const graph = yield ctx.getX6Graph();
                let rawNode = handlerArgs.nodeConfig;
                // 通过createNodeService来获取诸如nodeId的信息，如果返回的nodeid为空则不添加到画布
                if (createNodeService) {
                    const res = yield createNodeService(handlerArgs);
                    if (typeof res === 'boolean') {
                        return { err: 'createNodeService rejected' };
                    }
                    rawNode = res;
                }
                const nodeConfig = yield this.processNodeConfig(rawNode);
                let x6NodeCell;
                const eventOptions = Object.assign(Object.assign({}, options), { isCommand: true });
                if (cellFactory) {
                    /** 使用参数中的工厂方法 */
                    const cell = yield cellFactory(nodeConfig, this);
                    x6NodeCell = graph.addNode(cell, eventOptions);
                }
                else {
                    x6NodeCell = graph.addNode(nodeConfig, eventOptions);
                }
                /** add undo: delete node */
                ctx.addUndo(Disposable.create(() => __awaiter(this, void 0, void 0, function* () {
                    const nodeData = Object.assign({ id: x6NodeCell.id }, x6NodeCell.getData());
                    commandService.executeCommand(XFlowNodeCommands.DEL_NODE.id, {
                        nodeConfig: nodeData,
                    });
                })));
                return { nodeConfig: nodeConfig, nodeCell: x6NodeCell };
            }), runtimeHook);
            ctx.setResult(result);
            return this;
        });
        this.processNodeConfig = (nodeConfig) => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            /**
             * 1. react shape node 逻辑
             * 2. X6不会处理data数据, 仅透传。可以通过x6Node?.getData()方法获取这份数据
             */
            nodeConfig.data = Object.assign({}, nodeConfig);
            /** 非 react shape */
            if (nodeConfig.shape) {
                return nodeConfig;
            }
            /** react shape 使用react-portal-view提高性能 */
            if (!nodeConfig.view) {
                const graphConfig = yield ctx.getGraphConfig();
                nodeConfig.view = graphConfig.graphId;
            }
            /** 获取 react component */
            if (!nodeConfig.component) {
                const reactComponent = yield this.getNodeReactComponent(nodeConfig);
                const commands = ctx.getCommands();
                const modelService = ctx.getModelService();
                nodeConfig.shape = 'react-shape';
                nodeConfig.component = getNodeReactComponent(reactComponent, commands, modelService);
            }
            return nodeConfig;
        });
        this.getNodeReactComponent = (nodeConfig) => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            const hooks = ctx.getHooks();
            /** 获取Graph Config中用户预设的节点渲染需要的React组件 */
            const graphConfig = yield ctx.getGraphConfig();
            /** 通过hooks获取更多的组件 */
            const renderMap = yield hooks.reactNodeRender.call(graphConfig.nodeRender);
            /** 获取renderKey，没有renderKey时使用默认Key */
            const renderKey = graphConfig.nodeTypeParser(nodeConfig) || XFLOW_DEFAULT_NODE;
            /** 获取组件 */
            const reactComponent = renderMap.get(renderKey);
            if (!reactComponent) {
                console.error('react node component is missing:', graphConfig.nodeRender, renderKey, reactComponent);
            }
            return reactComponent;
        });
        /** undo cmd */
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            if (this.isUndoable()) {
                ctx.undo();
            }
            return this;
        });
        /** redo cmd */
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.isUndoable()) {
                yield this.execute();
            }
            return this;
        });
    }
    isUndoable() {
        const ctx = this.contextProvider();
        return ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], AddNodeCommand.prototype, "contextProvider", void 0);
AddNodeCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsAddNode.command.id },
    })
    /** 创建节点命令 */
], AddNodeCommand);
export { AddNodeCommand };
//# sourceMappingURL=node-add.js.map